import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import logoImg from "@/assets/logo.png";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border">
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img src={logoImg} alt="Hyper Haus" loading="lazy" width={85} height={48} className="h-10 w-auto" />
            <p className="text-sm text-muted-foreground leading-relaxed">
              Los Angeles' premier automotive customization shop. 40+ years of hands-on experience serving celebrities, supercars, and hypercars.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/hyper.haus"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Hyper Haus on Instagram"
                className="p-2 bg-muted rounded-lg hover:bg-primary/20 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span className="sr-only">Hyper Haus on Instagram</span>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm uppercase tracking-wider font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/automotive/ppf" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Paint Protection Film</Link></li>
              <li><Link to="/automotive/wraps" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Vehicle & Fleet Wraps</Link></li>
              <li><Link to="/automotive/ceramic" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Ceramic Coating</Link></li>
              <li><Link to="/automotive/tint" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Window Tint</Link></li>
              <li><Link to="/automotive/detailing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Detailing</Link></li>
              <li><Link to="/training" className="text-sm text-muted-foreground hover:text-foreground transition-colors">PPF Training</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm uppercase tracking-wider font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-sm text-muted-foreground hover:text-foreground transition-colors">All Services</Link></li>
              <li><Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
              <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm uppercase tracking-wider font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:3109169046" className="flex items-start gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  (310) 916-9046
                </a>
              </li>
              <li>
                <a href="mailto:biz@hyperhausla.com" className="flex items-start gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                  biz@hyperhausla.com
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=11934+S+La+Cienega+Blvd,+Hawthorne,+CA+90250"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                  11934 S La Cienega Blvd<br />
                  Hawthorne, CA 90250
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Hyper Haus. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Los Angeles' Premier Hypercar Protection Specialists
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
